import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useRef, useState } from 'react';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Link, SpaceBetween, Table, TextFilter } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiCheck } from '@mdi/js';
import Icon from '@mdi/react';
import BadgeUserType from '../../../../../components/extras/BadgeUserType';
import Favorites from '../../../../../components/extras/Favorites';
import SidePanelUser from '../../../../../components/extras/SidePanelUser';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemUser } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';



export const ReportsFinanceTransfersPage = () => {
  const { data, menu } = useGlobalState();
  const [user, setUser] = useState<ItemUser>();
  const mountedRef = useRef(false);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.split("?")[1]);
      const id = params.get("id");

      if (id) {
        if (!mountedRef.current) {
          //handleRefresh();
          mountedRef.current = true;
        }
        handleGetUser(parseInt(id))
      } else {
        setUser(undefined)
        //handleRefresh();
      }
    };
    window.addEventListener("hashchange", handleHashChange);
    handleHashChange();
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);
  const [users, setUsers] = useState<any[]>([]);
  const [filterValue, setFilterValue] = useState("");


  const filtered: any[] = users.filter((item) => {
    const searchWords = filterValue.toLowerCase().split(/\s+/).filter(Boolean);
    const text = [item.userPilot, item.userType].join(" ").toLowerCase().replace(/[^a-z0-9]/g, "");
    return searchWords.every((word) => text.includes(word.replace(/[^a-z0-9]/g, "")));
  });
  const handleGetUser = async (idUser: Number) => {
    try {
      setUser(undefined)
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/admin/users/get',
          'JWT': getCookie("JWT"),
          //  
        },
        body: JSON.stringify(
          {
            idUser: idUser,
            movements: true,
            bookings: true
          }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const data = await response.json();
      addNotificationStatus(data, setData);
      if (data.code == 0) {
        setUser(data.user);

      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally { setLoading(false) }
  }
  const handleRefresh = async () => {
    try {
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/reports/finance/transfers',
          'JWT': getCookie("JWT"),

        },

        body: JSON.stringify({})
      });
      if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

      const data = await response.json();
      if (data && data.users)
        setUsers(data.users)

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    handleRefresh();
  }, []);
  return (
    <CustomAppLayout
      toolsHide
      splitPanelOpen={!!user}

      onSplitPanelToggle={({ detail }) => {
        !detail.open ? window.location.hash = "reports/finances/transfers" : null
      }}

      splitPanelSize={600}
      splitPanel={
        <SidePanelUser user={user} />
      }
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <SpaceBetween size="s">
          <Header variant="h1" actions={<Favorites />}>Traspasos CPV a CPS</Header>
          <Table header={"Usuarios con condiciones de pasar de CPV a CPS: Más de 150 horas totales de planeador o mas de 10 años de antiguedad, no estar presente en ningún cargo CPS, siendo activo u honorario"}
            variant='embedded'
            filter={
              <TextFilter
                disabled={users.length === 0}
                filteringText={filterValue}
                filteringPlaceholder="Filtrar usuarios"
                onChange={({ detail }) => setFilterValue(detail.filteringText)}
              />
            }

            columnDefinitions={[
              { id: "user", header: "Usuario", cell: item => <Link onClick={() => window.location.hash = `reports/finances/transfers?id=${item.idUser}`}>{item?.userPilot}</Link> },
              { id: "userType", header: "Tipo", cell: item => <BadgeUserType size='medium' type='min' idUserType={item.idUserType} /> },
              { id: "HTP", header: "HºTP", cell: item => <>{item?.HH}{item?.HH >= 150 ? <Icon color="green" path={mdiCheck} size={0.7} /> : null}</>, },
              { id: "member", header: "Aº", cell: item => <>{item?.member}{item?.member >= 10 ? <Icon color="green" path={mdiCheck} size={0.7} /> : null}</> },
            ]}
            items={filtered || []}
          />
        </SpaceBetween>
      }
    />
  );
};
